import React, { memo } from 'react';
import dayjs from 'dayjs';

import { StyledDatePicker } from 'components/Shared/Forms/styles';

const DatePicker = ({ value, customFormat, ...props }) => (
    <StyledDatePicker {...props} value={value ? dayjs(value) : undefined} format={customFormat} />
);

export default memo(DatePicker);
